// Una promoción NO se puede tocar (seleccionar/editar/publicar) cuando su
// action_button llega como 'N/A': la promo ya empezó y no puede deshabilitarse, o una
// regla de negocio la bloquea. row.action proviene de promotion_data.action_button
// (ver MapPromotionToRow). Las filas de listing (isParentRow, sin action) no se ven
// afectadas: devuelven true.
export const isRowSelectable = (row) => {
  const action = row?.action;
  if (action == null) return true;

  const values = Array.isArray(action) ? action : String(action).split(",");
  const normalized = values
    .map((a) => String(a).trim().toUpperCase())
    .filter(Boolean);
  if (normalized.length === 0) return true;

  // No seleccionable solo si la única acción posible es 'N/A'.
  return !normalized.every((a) => a === "N/A");
};
